import React, { memo } from "react";
import { getClaim } from "actions/brandClaims";
import DropdownButton from "components/virtual/buttons/DropdownButton";
import CreateNewMenu from "components/virtual/menus/CreateNewMenu";
import partnershipSweepsIcon from "images/icons/partnership-sweepstakes.svg";
import SignupFormsIcon from "images/icons/signup-forms.svg";
import soloSweepsIcon from "images/icons/sweepstakes/solo-avatar.svg";
import { useSelector } from "react-redux";
import { isTrialExpired } from "utils/brandStripeBeltHelper";

function CreateNewButton() {
  const canCreatePartnershipSweepstakes = getClaim("sweepstakes.partnership.create");
  const canCreateSoloSweepstakes = getClaim("sweepstakes.solo.create");
  const currentBrand = useSelector((state) => state.currentBrand);
  const canViewForm = currentBrand?.features?.canViewSignupForm;

  // Check if trial has expired
  const trialExpired = isTrialExpired(currentBrand);

  const options = [
    canViewForm && {
      icon: <img alt="Signup Forms" src={SignupFormsIcon} />,
      label: "Signup Forms",
      description: "Turn your website visitors into subscribers",
      to: "/sms-marketing/acquisition-tools?signup_form=true",
    },
    {
      icon: <img alt="Solo Sweepstakes" src={soloSweepsIcon} />,
      label: "Solo Sweepstakes",
      description: "Engage leads and scale your audience",
      locked: !canCreateSoloSweepstakes || trialExpired,
      to: !canCreateSoloSweepstakes || trialExpired ? "/upgrade-plan" : "/new-solo-sweepstakes",
    },
    {
      icon: <img alt="Partnership Sweepstakes" src={partnershipSweepsIcon} />,
      label: "Partnership Sweepstakes",
      description: "Partner up and expand your audience reach",
      locked: !canCreatePartnershipSweepstakes || trialExpired,
      to: !canCreatePartnershipSweepstakes || trialExpired ? "/upgrade-plan" : "/new-campaign",
    },
  ].filter(Boolean);

  return <DropdownButton label="Create New" options={options} menuComponent={CreateNewMenu} />;
}

export default memo(CreateNewButton);
